export default "__VITE_ASSET__BeQx2$Rd__"